<template>
  <div>
    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 20vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      :undoRedoCellEditing="true"
      @grid-ready="onGridReady"
      :frameworkComponents="frameworkComponents"
      @cellClicked="onRowClicked"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    ></ag-grid-vue>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "data-usage-detail",
  props: {
    username: { type: String }
  },
  components: { AgGridVue },
  data: () => ({
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true
    },
    columnDefs: null,
    gridOptions: {},
    frameworkComponents: null,
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "Date Range",
        field: "dateRange",
        sortable: true,
        maxWidth: 195,
        filter: true,
      },
      {
        headerName: "Download(MB)",
        field: "downloadusage",
        sortable: true,
        filter: true,
        maxWidth: 150,
      },
      {
        headerName: "Upload(MB)",
        field: "uploadusage",
        sortable: true,
        filter: true,
        maxWidth: 140,
      }
    ];

    vm.defaultColDef = {
      autoHeight: true,
    };
    vm.getDataUsage();
  },
  computed: {
    filteredItems: function () {
      let vm = this;
      return vm.items;
    },
  },
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      var payload = { quoteID: args.data.quoteId };
    },
    getDataUsage(){
      let vm =this;
      vm.items = [{"dateRange":"11/01/2023 - 12/01/2023", "downloadusage":"123", "uploadusage":"456"}];
    }
  }
}
</script>

<style scoped>

</style>
